module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\" ng-app=\"app\" ng-strict-di>\n  <div ui-view=\"ng-admin\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 740
// module chunks = 0